import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import AccordionContent from '../vue/AccordionContent.vue';
import FeatureVideo from '../vue/FeatureVideo.vue';
import Testimonials from '../vue/Testimonials.vue';
import HeroSlider from '../vue/HeroSlider.vue';
import MobileHeader from '../vue/MobileHeader.vue';
import ScrollToLink from '../vue/ScrollToLink.vue';
import GoogleMap from '../vue/GoogleMap.vue';
import BlogPost from '../vue/BlogPost.vue';
import VueLazyload from 'vue-lazyload';
import AutoModal from '../vue/AutoModal.vue';
import ServiceAreas from '../vue/ServiceAreas.vue';
import DropdownLinks from '../vue/DropdownLinks.vue';

export default {
  init() {


    /* Exclusions

     Some plugins cause conflicts with Vue because they place inline <script> tags within the #app
     container. To work around this, I'm detaching anything with the class .vue-disable first,
     then re-attaching it at the bottom of this script once Vue has been instantiated.
    ---------------------------------------------------------------------------------------------------- */

    let matchingElements = document.getElementsByClassName('vue-disable'),
      hiddenMarkup = [];

    for (var i = 0; i < matchingElements.length; i++) {
      hiddenMarkup.push(matchingElements[i].innerHTML);
      matchingElements[i].innerHTML = '';
    }



    /* Vue
    ---------------------------------------------------------------------------------------------------- */

    Vue.config.productionTip = false;

    Vue.use(VueLazyload);

    Vue.use(VueGoogleMaps, {
      load: {
        key: (document.getElementById('app')) ? document.getElementById('app').getAttribute('data-google-maps-api-key') : '',
      },
      installComponents: true,
    });

    new Vue({
      data: {
        topScrollThreshold: 100,
        isScrolled: false,
        isShowingFormOnMobile: false,
      },

      components: {
        AccordionContent,
        FeatureVideo,
        Testimonials,
        HeroSlider,
        MobileHeader,
        ScrollToLink,
        GoogleMap,
        BlogPost,
        AutoModal,
        ServiceAreas,
        DropdownLinks,
      },

      methods: {
        didScroll () {
          this.isScrolled = (window.scrollY > this.topScrollThreshold);
        },

        didSelectOpenForm: function() {
          var self = this;
          self.isShowingFormOnMobile = true;
        },
      },

      created () {
        window.addEventListener('scroll', this.didScroll);
      },

      destroyed () {
        window.removeEventListener('scroll', this.didScroll);
      },

      mounted () {

      },

    }).$mount('#app');


    /* Re-Attach exclusions
    ---------------------------------------------------------------------------------------------------- */

    for (var ii = 0; ii < matchingElements.length; ii++) {
        matchingElements[ii].innerHTML = hiddenMarkup[ii];
    }


  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js